<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- <audio loop autoplay src="http://music.reborndata.com/music/201712/20171212/201712121741057328.mp3" id="audio2"></audio> -->
    <audio id="audio" loop autoplay :src="defaultMusic"></audio>
    <audio
    ref="music"
      id="memberAudio"
      src="http://api.xiaoaitt.com/UploadFiles/Music/2017/11/24/Heaven/MusicInfo/20171124154955.mp3"
      loop
      preload="auto"
    ></audio>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // defaultMusic: "http://www.jq22.com/demo/vuekgbfq202003082021/xs.mp3",
      defaultMusic: "",
    };
  },
  created() {
    var that = this;
    var _jssdkConfig = sessionStorage.getItem("JssdkConfig");
    console.log("jssdkConfig:" + _jssdkConfig);
    if (_jssdkConfig == null) {
      that.$weixin.GetJssdkConfig(that);
    }
  },
};
</script>
<!-- <style lang="less">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
  </style> -->
<style>
* {
  padding: 0px;
  margin: 0px;
  border: 0px;
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
  box-sizing: border-box;
}
article,
aside,
footer,
header,
hgroup,
main,
nav,
section {
  margin: 0;
  padding: 0;
  border: 0px;
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
}
body {
  line-height: 1.6;
  color: #141414;
  font-size: 14px;
  /*background-color: #f0f2f4;*/
  background-color: #fff;
  /*font-family: 'PingFang SC', Helvetica, 'STHeiti STXihei', 'Microsoft YaHei', Tohoma, Arial, sans-serif;*/
  font-family: "Microsoft Yahei", Tohoma, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}
a {
  color: #141414;
}
/*a:active{
    color: #1989fa;
  }*/
img {
  border: 0;
  max-width: 100%;
}
.van-field__control::-webkit-input-placeholder {
  color: #bbb;
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #aaa !important;
}
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: #d3d3d3;
}
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: #d3d3d3;
}
.van-step--finish {
  color: #d4d4d4;
}
/*滚动条样式*/
input[type="button"],
input[type="submit"],
input[type="search"],
input[type="reset"] {
  -webkit-appearance: none;
}

textarea {
  -webkit-appearance: none;
}
.img-circle {
  border-radius: 50%;
}
.navBarSpace {
  padding-top: 46px; /*no*/
}
.tabbarSpace {
  padding-bottom: 50px; /*no*/
}
.van-tabbar-item__icon .iconfont {
  font-size: 18px !important;
}
.bgColor {
  background-color: #f2f2f2;
}
.bg {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: #f2f2f2;
}
.bgfff {
  background-color: #fff;
}
.navbarBg {
  background-color: #fbfbfb;
}
b,
strong {
  font-weight: 700;
}
em,
i {
  font-style: normal;
}
.text-center {
  text-align: center !important;
}
.text-right {
  text-align: right !important;
}
.t12 {
  font-size: 12px !important;
}
.t13 {
  font-size: 13px !important;
}
.t14 {
  font-size: 14px !important;
}
.t15 {
  font-size: 15px !important;
}
.t16 {
  font-size: 16px !important;
}
.t18 {
  font-size: 18px !important;
}
.t21 {
  font-size: 21px !important;
}
.t24 {
  font-size: 24px !important;
}
small {
  font-size: 65%;
}
.cred {
  color: #d54d4d !important;
}
.cgreen {
  color: #6ebd05 !important;
}
.corange {
  color: #e78639 !important;
}
.c0 {
  color: #141414 !important;
}
.c2 {
  color: #222 !important;
}
.c3 {
  color: #333 !important;
}
.c4 {
  color: #444 !important;
}
.c5 {
  color: #555 !important;
}
.c6 {
  color: #666 !important;
}
.c7 {
  color: #777 !important;
}
.c8 {
  color: #888 !important;
}
.c9 {
  color: #999 !important;
}
.ca {
  color: #a6a6a6 !important;
}
.cb {
  color: #bbb !important;
}
.cc {
  color: #ccc !important;
}
.ce {
  color: #eee !important;
}
.cf {
  color: #fff !important;
}
.hidden {
  display: none;
}
.bold {
  font-weight: 500;
}
.hlight {
  color: #24a378 !important;
}
.flexbox {
  display: flex;
  align-items: center;
}
.flexmid {
  flex: 1;
}
.clearfix {
  overflow: auto;
  zoom: 1;
}
.ellipsis-1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;

  white-space: normal !important;
  text-overflow: ellipsis;
  word-wrap: break-word;

  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.title-linelt {
  font-size: 14px;
  font-weight: normal;
  color: #666;
  position: relative;
  padding-left: 10px;
}
.title-linelt:before {
  position: absolute;
  left: 0;
  top: 50%;
  content: " ";
  background: #e78639;
  width: 3px;
  height: 18px;
  margin-top: -9px;
}
.martop0 {
  margin-top: 0 !important;
}
.martop10 {
  margin-top: 10px !important;
}
.marbtm10 {
  margin-bottom: 10px !important;
}
.marbtm4 {
  margin-bottom: 4px !important;
}
.marright4 {
  margin-right: 4px !important;
}
.marright10 {
  margin-right: 10px !important;
}

.panel {
  margin-top: 10px;
  background-color: #fff;
}
/*******vant样式重置*******/
.van-dropdown-menu__title {
  font-size: 14px;
}
.van-overlay {
  background-color: rgba(0, 0, 0, 0.65);
}
.van-image-preview__overlay {
  background-color: rgba(0, 0, 0, 0.9) !important;
}
.van-cell {
  font-size: 15px;
}
.van-cell-group__title + .van-cell-group {
  margin-top: 0;
}
.van-cell--clickable:active {
  background-color: #f6f6f6;
}
.van-cell-group {
  margin-top: 10px;
}
.van-cell__title {
  /*color: #555;*/
}
.van-cell__value {
  /*color: #000;*/
}
.van-field__label {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  flex: none;
  box-sizing: border-box;
  width: 90px;
  color: #555;
}
.van-count-down {
  color: #ec6c00 !important;
}
/*vant 导航栏*/
.van-nav-bar {
  background-color: #24a378 !important;
}
.van-nav-bar__left .van-icon {
}
.van-nav-bar .van-icon {
  color: #fff !important;
  font-size: 22px; /*no*/
}
.van-nav-bar .fa {
  color: #fff !important;
  font-size: 22px; /*no*/
  vertical-align: middle;
}
.van-nav-bar__text {
  color: #fff !important;
}
.van-nav-bar__text:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
.van-nav-bar__title {
  color: #fff !important;
  position: relative;
}
.van-nav-bar__right {
  display: flex;
  align-items: center;
  height: 100%;
}
.van-nav-bar__right .iconbtn {
  margin-left: 15px;
}
.van-index-anchor--sticky {
  background-color: #24a378;
}
.van-button.mybtn {
  color: #fff;
  background-color: #24a378;
  border: 1px solid #24a378;
}
.van-button--plain.mybtn {
  color: #24a378 !important;
  background-color: #fff;
}
.van-button.whitebtn {
  color: #fff;
  background-color: transparent;
  border: 1px solid #fff;
}
.van-button--plain.whitebtn {
  color: #fff !important;
  background-color: transparent;
}
.van-button--plain.whitebtn.minbtn {
  min-width: 132px;
}
.btn-area {
  margin: 24px 15px 15px;
  text-align: center;
}
.van-swipe__indicator {
  background-color: #555;
}
/********weui-grids************/
.weui-grids {
  position: relative;
  overflow: hidden;
}
.weui-grids:before {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 1px;
  border-top: 1px solid #d9d9d9;
  color: #d9d9d9;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.weui-grids:after {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  width: 1px;
  bottom: 0;
  border-left: 1px solid #d9d9d9;
  color: #d9d9d9;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleX(0.5);
  transform: scaleX(0.5);
}
.weui-grid {
  position: relative;
  float: left;
  padding: 20px 10px;
  width: 33.33333333%;
  box-sizing: border-box;
}
.weui-grid:before {
  content: " ";
  position: absolute;
  right: 0;
  top: 0;
  width: 1px;
  bottom: 0;
  border-right: 1px solid #d9d9d9;
  color: #d9d9d9;
  -webkit-transform-origin: 100% 0;
  transform-origin: 100% 0;
  -webkit-transform: scaleX(0.5);
  transform: scaleX(0.5);
}
.weui-grid:after {
  content: " ";
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 1px;
  border-bottom: 1px solid #d9d9d9;
  color: #d9d9d9;
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.weui-grid:active {
  background-color: #ececec;
}
.weui-grid__icon {
  width: 28px;
  height: 28px;
  margin: 0 auto;
}
.weui-grid__icon img {
  display: block;
  width: 100%;
  height: 100%;
}
.weui-grid__icon + .weui-grid__label {
  margin-top: 5px;
}
.weui-grid__label {
  display: block;
  text-align: center;
  color: #000000;
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.weui-cells__tips {
  padding: 0 15px;
  margin: 10px 0;
  font-size: 12px;
  color: #999;
}
.weui-cells__tips p {
  line-height: 1.4;
  margin-bottom: 4px;
}
/*weui-form-preview*/
.weui-form-preview {
  position: relative;
  background-color: #ffffff;
}
.weui-form-preview:before {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 1px;
  border-top: 1px solid #e5e5e5;
  color: #e5e5e5;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.weui-form-preview:after {
  content: " ";
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 1px;
  border-bottom: 1px solid #e5e5e5;
  color: #e5e5e5;
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.weui-form-preview__hd {
  position: relative;
  padding: 10px 15px;
  text-align: right;
  line-height: 2.5em;
}
.weui-form-preview__hd:after {
  content: " ";
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 1px;
  border-bottom: 1px solid #e5e5e5;
  color: #e5e5e5;
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  left: 15px;
}
.weui-form-preview__hd .weui-form-preview__value {
  font-style: normal;
  font-size: 1.6em;
}
.weui-form-preview__bd {
  padding: 10px 15px;
  font-size: 0.9em;
  text-align: right;
  color: #999999;
  line-height: 2;
}
.weui-form-preview__ft {
  position: relative;
  line-height: 50px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.weui-form-preview__ft:before {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 1px;
  border-top: 1px solid #d5d5d6;
  color: #d5d5d6;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.weui-form-preview__item {
  overflow: hidden;
}
.weui-form-preview__label {
  float: left;
  margin-right: 1em;
  /*min-width:4em;*/
  color: #999999;
  /*text-align:justify;
    text-align-last:justify;*/
}
.weui-form-preview__value {
  display: block;
  overflow: hidden;
  word-break: normal;
  word-wrap: break-word;
}

/***********/
.navbarBg {
  background-color: #24a378 !important;
}
/*纪念馆列表*/
.hall-item {
  display: block;
  margin: 14px;
  border: 1px solid #eee;
  border-radius: 4px;
  height: 145px;
  position: relative;
  box-sizing: content-box;
  padding: 0;
}
.hall-list {
  display: flex;
  align-items: center;
}
.hall-list > .bd {
  flex: 1;
  overflow: hidden;
  height: 100%;
  padding: 10px 15px;
}
.hall-list > .bd > .sz-name {
  font-weight: normal;
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
.hall-list > .bd > .sz-des {
  margin-top: 6px;
}
.hall-list > .bd > .sz-des > p {
  font-size: 12px;
  color: #888;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  line-height: 1.4;
}
.hall-item .double-tag {
  position: absolute;
  top: -4px;
  right: 86px;
  width: 52px;
}
.hall-list > .ft {
  width: 112px;
  height: 145px;
}
.hall-list > .ft > .avatar {
  display: block !important;
  width: 100%;
  height: 100%;
  border-radius: 0 4px 4px 0;
  object-fit: cover;
}
/*隐私弹出框*/
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.dialog-private {
  position: relative;
  background-color: #fff;
  padding: 25px;
  width: 320px;
  text-align: left;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.dialog-private > .title {
  font-size: 20px;
  color: #444;
  font-weight: normal;
}
.dialog-private > .control-input {
  margin-top: 6px;
  border: 1px solid #ddd;
  padding: 10px 15px;
  margin-bottom: 12px;
  width: 100%;
}
.dialog-private > .tips {
  font-size: 12px;
  color: #666;
  margin-top: 21px;
  margin-bottom: 6px;
}
.dialog-private > .closeBtn {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #aaa;
  font-size: 24px;
}
/*关注纪念馆列表*/
.follow-item {
  display: block;
  margin: 14px;
  border: 1px solid #eee;
  border-radius: 4px;
  height: 135px;
  position: relative;
  box-sizing: content-box;
}
.follow-list {
  display: flex;
  align-items: center;
  height: 100%;
  position: relative;
}
.follow-list > .bd {
  flex: 1;
  overflow: hidden;
  margin: 10px 15px;
  text-align: center;
}
.follow-list > .bd > .sz-name {
  font-weight: normal;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
.follow-list > .bd > .sz-des {
  margin-top: 14px;
}
.follow-item .double-tag {
  position: absolute;
  top: -4px;
  left: 84px;
  width: 52px;
}
.follow-list > .ft {
  width: 112px;
  height: 135px;
}
.follow-list > .ft .avatar {
  display: block !important;
  width: 112px;
  height: 135px;
  border-radius: 4px 0 0 4px;
  object-fit: cover;
}
.follow-item .van-swipe__indicator {
  background-color: #ddd;
}
/**********/
.image-uploader {
  margin-left: 15px;
  margin-top: 20px;
}
/***底部导航栏***/
.appbarSpace {
  padding-bottom: 50px;
}
.appbarBottom {
  position: fixed !important;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  height: 50px;
  overflow: hidden;
  display: flex;
  align-items: center;
  background-color: #fff;
}
.appbarBottom > .item {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 6px;
  overflow: hidden;
}
.appbarBottom > .item > .van-icon {
  font-size: 21px;
  color: #555;
}
.appbarBottom > .item > .text {
  font-size: 12px;
  color: #777;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.appbarBottom > .item.active > .van-icon {
  color: #24a378;
}
.appbarBottom > .item.active > .text {
  color: #24a378;
}
/*评论样式*/
.comment-box {
  margin: 15px;
}
.comment-action {
  display: flex;
  align-items: center;
}
.comment-action .button {
  margin-right: 15px;
  font-size: 14px;
  color: #555;
  display: flex;
  align-items: center;
}
.comment-action .button i {
  font-size: 18px;
  margin-right: 6px;
}
.comment-action .button.active {
  color: #24a378;
}
.comment-action > .right-des {
  font-size: 12px;
  color: #999;
}
.comment-content {
  background-color: #f2f2f2;
  padding: 10px 5px;
  margin-top: 4px;
}
.comment-content > .comment-list {
  display: flex;
  align-items: flex-start;
  padding: 5px 10px;
}
.comment-list > .hd {
  width: 36px;
  height: 36px;
  margin-right: 10px;
}
.comment-list > .bd {
  flex: 1;
  overflow: hidden;
}
.cmt-header {
  display: flex;
  align-items: center;
  overflow: hidden;
}
.cmt-header > .user {
  flex: 1;
  overflow: hidden;
  font-size: 13px;
  color: #24a378;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.cmt-header > .date {
  margin-left: 12px;
  font-size: 12px;
  color: #aaa;
}
.cmt-body {
  font-size: 13px;
  color: #555;
  line-height: 1.4;
}
/*评论弹出*/
.cmt-popup {
  background-color: #f2f2f2;
  padding: 10px;
}
.cmt-popup .van-cell {
  background-color: #fff !important;
  border-radius: 4px;
  padding: 6px;
}
.cmt-popup > .btmbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
}
/***时空信箱列表***/
.mainbox-list {
  padding: 14px 15px;
}
.mainbox-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.mainbox-header > .hd {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}
.mainbox-header > .bd {
  flex: 1;
  overflow: hidden;
}
.mainbox-header > .bd > .name {
  font-size: 13px;
  color: #555;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.mainbox-header > .bd > .date {
  font-size: 12px;
  color: #999;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.mainbox-header > .bd > .mall {
  font-size: 12px;
  color: #888;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 3px;
}
.mainbox-header > .ft {
  margin-left: 15px;
}
.mainbox-header > .ft > .van-icon {
  font-size: 21px;
  color: #888;
}
.mainbox-body .text-box {
  margin-bottom: 6px;
  font-size: 15px;
  color: #444;
  line-height: 1.5;
}
.mainbox-body .image-box {
  /*margin-bottom: 6px;*/
}
.image {
  position: relative;
  height: 0;
  font-size: 0;
  width: 100%;
  padding-bottom: 100%;
  margin-bottom: 5px;
}
.image .van-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.mainbox-list .comment-box {
  margin: 4px 0;
}

/*创建纪念馆*/
.createPage {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #24a378 !important;
}
.createBg {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  padding-top: 46px;
}
.createPage .mynavbar {
  background-color: rgba(0, 0, 0, 0.45) !important;
}
.createPage .block {
  position: relative;
  padding-top: 46px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  height: 100%;
}
.createPage .field-item {
  display: flex;
  align-items: center;
  margin: 21px 15%;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 0 15px;
  height: 48px;
  border-radius: 3px;
}
.createPage .field-item > .hd {
  margin-right: 12px;
  width: 34px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.createPage .field-item > .hd i {
  font-size: 22px;
  color: #fff;
}
.createPage .field-item > .hd img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}
.createPage .field-item > .bd {
  flex: 1;
  overflow: hidden;
}
.createPage .field-item > .ft {
  margin-left: 15px;
  display: flex;
  align-items: center;
}
.createPage .field-item .van-cell {
  padding: 0;
  background-color: transparent !important;
}
.createPage .field-item .van-field__control {
  color: #fff;
}
.createPage .field-item input::-webkit-input-placeholder,
.createPage textarea::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
}
/****搜索页***/
.search-list {
  padding: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  background-color: #fff;
  overflow: hidden;
}
.search-list > .hd {
  width: 86px;
  height: 86px;
  margin-right: 10px;
}
.search-list > .bd {
  flex: 1;
  overflow: hidden;
  position: relative;
}
.search-list > .bd > .title {
  font-weight: normal;
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.search-list > .bd > .des {
  font-size: 13px;
  color: #777;
  margin-top: 4px;
}
.search-list > .ft {
  margin-left: 15px;
  text-align: right;
}
.searchPage {
  padding-top: 54px;
}
.searchForm {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9;
}

.button-area-one {
  margin: 24px 15px 10px;
}
.button-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 24px 15px;
}
.button-area .van-button {
  width: 140px;
}
/***登录注册页面***/
.loginPage {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #000 !important;
}
.loginBg {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.loginPage .mynavbar {
  background-color: transparent !important;
}
.loginPage .field-item {
  display: flex;
  align-items: center;
  margin: 5px 14%;
  padding: 0;
  height: 50px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.loginPage .field-item > .hd {
  margin-right: 10px;
  width: 36px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.loginPage .pwd-block .field-item > .hd {
  width: 52px;
}
.loginPage .field-item > .hd i {
  font-size: 24px;
  color: #fff;
}
.loginPage .field-item > .hd img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.loginPage .field-item > .hd .label {
  font-size: 14px;
  color: #fff;
  width: 100%;
  text-align: left;
}
.loginPage .field-item > .bd {
  flex: 1;
  overflow: hidden;
}
.loginPage .field-item > .ft {
  margin-left: 15px;
}
.loginPage .field-item .van-cell {
  padding: 0;
  background-color: transparent !important;
}
.loginPage .field-item .van-field__control {
  color: #fff;
}
.loginPage .field-item input::-webkit-input-placeholder,
.loginPage textarea::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}
.loginPage .block {
  position: relative;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  height: 100%;
}
.loginPage .backButton {
  margin: 10px;
}
.loginPage .btn-area {
  margin: 30px auto 14px;
}
.loginbtn {
  background-color: rgba(0, 0, 0, 0.45) !important;
  border: 0 none !important;
  padding: 0 30px !important;
  height: 50px;
  line-height: 50px;
  color: #fff !important;
  font-size: 16px !important;
  letter-spacing: 4px;
}
.other-login {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 30px;
}
.other-login .item {
  margin: 0 3px;
}
.other-login .item img {
  width: 75px;
  height: 31px;
  object-fit: contain;
}
.forgetbtn {
  font-size: 12px;
  color: #fff;
  margin: 0 14%;
}
.user-agreement {
  font-size: 12px;
  text-align: center;
  color: #fff;
  margin-top: 14px;
  margin-bottom: 24px;
}
.user-agreement .hlight {
  color: #f60 !important;
}
/****祭拜礼物******/
.movegift {
  width: 176px;
  height: 176px;
  background-size: 100% 100%;
  position: fixed;
  bottom: -146px;
  margin-left: -88px;
  left: 50%;
  margin-bottom: -73px;
  z-index: 20;
  opacity: 1;
  object-fit: contain;
}

.movegift_lb {
  width: 176px;
  height: 176px;
  background-size: 100% 100%;
  position: fixed;
  bottom: 100px;
  margin-left: -88px;
  left: 50%;
  /* margin-bottom: -73px; */
  z-index: 20;
  opacity: 1;
  object-fit: contain;
}

.fade-enter-active {
  -webkit-animation: longer 2s linear;
  animation: longer 2s linear;
}
@-webkit-keyframes longer {
  0% {
    bottom: -4rem;
  }
  35% {
    bottom: 50%;
  }
  100% {
    bottom: 50%;
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }
}
@keyframes longer {
  0% {
    bottom: -4rem;
  }
  35% {
    bottom: 50%;
  }
  100% {
    bottom: 50%;
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }
}

/**********************  佣金明细css **********************/
.commission-filter {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #f8f8f8;
}
.commission-filter .filter-btn {
  background: #fff;
  height: 26px;
  padding: 0 20px 0 10px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  margin-left: 10px;
}
/**下拉菜单**/
#modal-div {
  position: absolute;
  top: 36px;
  left: 0;
  z-index: 100000;
}
.menu_ul {
  width: 100px;
  right: 0;
}
.menu_ul .menu_li {
  background-color: #fff;
}
.menu_ul .menu_li:first-child {
  border-radius: 6px 6px 0 0;
  position: relative;
}
.menu_ul .menu_li:first-child:before {
  content: "";
  position: absolute;
  width: 1px;
  height: 1px;
  border: 5px solid transparent;
  border-bottom-color: #fff;
  right: 50%;
  top: -10px;
  margin-right: -5px;
}
.menu_ul .menu_li:last-child {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.menu_ul .menu_li .a {
  text-align: center;
  padding: 10px 0;
  margin: 0 10px;
  color: #333 !important;
  text-decoration: none !important;
  display: block;
  border-bottom: 1px solid #eee;
}
.menu_ul .menu_li .a.active {
  color: #24a378 !important;
}
.commission-nav {
  display: flex;
  align-items: center;
  height: 90px;
  background: #fff;
}
.commission-nav .item {
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.commission-nav .item .tit {
  font-size: 14px;
  color: #555;
}
.commission-nav .item .num {
  font-size: 25px;
  color: orangered;
}
.commission-nav .line {
  width: 1px;
  height: 100%;
  background: #ddd;
}
.commission-list {
  margin: 10px;
  background: #fff;
  border-radius: 8px;
  padding: 0 12px;
}
.commission-list > .hd {
  display: flex;
  align-items: center;
  overflow: hidden;
  padding-top: 15px;
}
.commission-list > .hd .left-cnt {
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.left-cnt .btn {
  font-size: 12px;
  color: #fff;
  background: -webkit-linear-gradient(to right, #fe8003, #fe4e00);
  background: linear-gradient(to right, #fe8003, #fe4e00);
  margin-right: 6px;
  padding: 2px 6px;
  border-radius: 4px;
  transform: scale(0.85);
}
.left-cnt .date {
  font-size: 12px;
  color: #bbb;
}
.commission-list > .hd .status {
  margin-left: 10px;
  font-size: 14px;
  color: crimson;
  text-align: right;
}
.commission-list > .bd {
  padding: 15px 4px;
}
.commission-list > .bd .card-info {
  display: flex;
  align-items: center;
}
.card-info > .card-hd {
  width: 160px;
  height: 92px;
  margin-right: 15px;
}
.card-info > .card-hd .avatar {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.card-info > .card-bd {
  flex: 1;
  overflow: hidden;
}
.card-info > .card-bd .info-item {
  margin: 2px 0;
}
.card-info > .card-bd .info-item .label {
  font-size: 13px;
  color: #999;
}
.card-info > .card-bd .info-item .text {
  font-size: 15px;
  color: #333;
}
.commission-list > .ft {
  padding: 10px 0;
  display: flex;
  align-items: center;
  border-top: 1px solid #eee;
}
.commission-list > .ft .member-info {
  flex: 1;
  overflow: hidden;
  font-size: 13px;
  color: #999;
  display: flex;
  align-items: center;
}
.commission-list > .ft .member-info .tit {
  color: #ccc;
  margin-right: 10px;
}
.commission-list > .ft .member-info span {
  flex-shrink: 0;
}
.commission-list > .ft .member-info .name {
  display: block;
  color: #999;
  margin-right: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 96px;
}
.commission-list > .ft .income {
  font-size: 13px;
  color: #999;
  margin-left: 10px;
}
.commission-list > .ft .income span {
  margin-left: 10px;
}
.commission-list > .ft .income .money {
  font-size: 15px;
  color: crimson;
}
.change-btn {
  width: 76%;
  height: 2.3rem;
  background-color: #24a378;
  border-radius: 90px;
  text-align: center;
  line-height: 2.3rem;
  margin: auto;
  margin-top: 2.2rem;
  font-size: 0.8rem;
  color: #fff;
}
</style>
